var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { legalDepositsLibrariesIdMessageTemplates, legalDepositsLibrariesIdMessageTemplatesPreview, legalDepositsLibrariesIdMessageTemplatesType, } from "../types/apiPaths";
export var fetchLibraryMessageTemplates = function (kyInstance, libraryId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsLibrariesIdMessageTemplates(libraryId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                console.error("Error fetching library message templates:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var saveMessageTemplate = function (kyInstance, libraryId, type, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.put(legalDepositsLibrariesIdMessageTemplatesType(libraryId, type), { json: payload, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Save error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error saving message template:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var resetMessageTemplate = function (kyInstance, libraryId, type) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.delete(legalDepositsLibrariesIdMessageTemplatesType(libraryId, type), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Reset error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                console.error("Error resetting message template:", error_3);
                throw error_3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var previewMessageTemplate = function (kyInstance, libraryId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(legalDepositsLibrariesIdMessageTemplatesPreview(libraryId), { json: payload, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Preview error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_4 = _a.sent();
                console.error("Error previewing message template:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
